// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3iquD","errors":"Errors_errors__biyOA"};